import { cn } from '@shared/lib';
import token160 from './token-160.webp';
import token48 from './token-48.webp';
import token96 from './token-96.webp';

interface TokenIconProps {
  /** Сторона в px. До 24 — файл 48 px, до 48 — 96 px, больше — 160 px (с запасом на 2x). */
  size?: number;
  className?: string;
}

/**
 * Жетон — единица дневного лимита на карточки с AI (решение владельца 2026-10-13):
 * янтарная монета с огоньком, как на лендинге. Картинка декоративная — число жетонов
 * рядом всегда подписано текстом.
 */
export function TokenIcon({ size = 18, className }: TokenIconProps) {
  const [src, srcSet] =
    size <= 24
      ? [token48, `${token48} 1x, ${token96} 2x`]
      : size <= 48
        ? [token96, `${token96} 1x, ${token160} 2x`]
        : [token160, undefined];
  return (
    <img
      src={src}
      srcSet={srcSet}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn('shrink-0 select-none', className)}
    />
  );
}
